var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"this-week"},[_c('food-menu',{attrs:{"isThisWeek":_vm.isThisWeek}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }